module.exports = __webpack_public_path__ + "media/images/svg/quotes-58d350376ba8c6b500edb23fa84d392c.svg";